export const PAGE_METADATA = {
  // Home Page
  home: {
    title: 'Home - Bus Ticket Booking System',
    description: 'Book bus tickets online with our easy-to-use system. Find routes, check schedules, and reserve your seat today.'
  },

  // Booking Pages
  booking: {
    title: 'Book Tickets - Bus Ticket System',
    description: 'Find and book bus tickets for your journey. Select your route, date, and seats with ease.'
  },
  'booking-details': {
    title: 'Booking Details - Bus Ticket System',
    description: 'View your booking details, PNR number, and trip information.'
  },
  'booking-print': {
    title: 'Print Ticket - Bus Ticket System',
    description: 'Print your bus ticket with QR code and all necessary travel information.'
  },
  'manual-booking': {
    title: 'Manual Booking - Bus Ticket System',
    description: 'Create bookings manually for customers at the counter or over the phone.'
  },

  // Admin Pages
  'admin-dashboard': {
    title: 'Admin Dashboard - Bus Ticket System',
    description: 'Manage your bus ticketing system from the admin dashboard.'
  },
  'admin-bookings': {
    title: 'Admin Bookings - Bus Ticket System',
    description: 'View and manage all bookings in the system from the admin panel.'
  },
  'admin-booking-monitor': {
    title: 'Booking Monitor - Admin Panel',
    description: 'Monitor and manage all bookings in real-time from the admin panel.'
  },
  'admin-routes': {
    title: 'Manage Routes - Admin Panel',
    description: 'Add, edit, and manage bus routes from the admin panel.'
  },
  'admin-buses': {
    title: 'Manage Buses - Admin Panel',
    description: 'Manage bus fleet, schedules, and configurations from the admin panel.'
  },
  'admin-providers': {
    title: 'Manage Providers - Admin Panel',
    description: 'Manage bus providers and their information from the admin panel.'
  },

  // Counter Pages
  'counter-dashboard': {
    title: 'Counter Dashboard - Bus Ticket System',
    description: 'Counter dashboard for managing bookings and customer service.'
  },
  'counter-bookings': {
    title: 'Counter Bookings - Bus Ticket System',
    description: 'Manage bookings from the counter dashboard.'
  },
  'counter-booking-monitor': {
    title: 'Counter Booking Monitor',
    description: 'Monitor and manage bookings from the counter booking monitor.'
  },
  'counter-manual-booking': {
    title: 'Manual Booking - Counter Panel',
    description: 'Create manual bookings for customers at the counter.'
  },
  'counter-on-hold-bookings': {
    title: 'On-Hold Bookings - Counter Panel',
    description: 'Manage on-hold bookings from the counter panel.'
  },

  // Support Pages
  'support-dashboard': {
    title: 'Support Dashboard - Bus Ticket System',
    description: 'Support dashboard for assisting customers and managing tickets.'
  },
  'support-bookings': {
    title: 'Support Bookings - Bus Ticket System',
    description: 'View and assist with bookings from the support panel.'
  },
  'support-manual-booking': {
    title: 'Support Manual Booking',
    description: 'Create bookings for customers from the support panel.'
  },

  // Provider Pages
  'provider-dashboard': {
    title: 'Provider Dashboard - Bus Ticket System',
    description: 'Provider dashboard for managing your bus services.'
  },
  'provider-bookings': {
    title: 'Provider Bookings - Bus Ticket System',
    description: 'View and manage bookings for your bus services.'
  },

  // Customer Pages
  'customer-dashboard': {
    title: 'Customer Dashboard - Bus Ticket System',
    description: 'View and manage your personal bookings and trips from your customer dashboard.'
  },
  'customer-offers': {
    title: 'Special Offers - Bus Ticket System',
    description: 'Check out our latest discounts and special offers for bus tickets.'
  },
  'customer-history': {
    title: 'Booking History - Bus Ticket System',
    description: 'View your booking history and past trips.'
  },
  'customer-bookings': {
    title: 'My Bookings - Bus Ticket System',
    description: 'View and manage your bus booking history.'
  },
  'customer-profile': {
    title: 'Customer Profile - Bus Ticket System',
    description: 'Manage your personal profile and account settings.'
  },
  'customer-support': {
    title: 'Customer Support - Bus Ticket System',
    description: 'Get help and support for your bus ticketing needs.'
  },

  // Search Page
  search: {
    title: 'Search Buses - Bus Ticket System',
    description: 'Search for available buses and book your tickets.'
  },
  
  // Authentication Pages
  login: {
    title: 'Login - Bus Ticket System',
    description: 'Log in to your bus ticketing system account.'
  },
  register: {
    title: 'Register - Bus Ticket System',
    description: 'Create a new account for the bus ticketing system.'
  },
  'forgot-password': {
    title: 'Forgot Password - Bus Ticket System',
    description: 'Reset your password for the bus ticketing system.'
  },

  // Booking Pages
  'booking-confirmation': {
    title: 'Booking Confirmation - Bus Ticket System',
    description: 'Your bus ticket booking confirmation.'
  },
  
  // About and Contact
  about: {
    title: 'About Us - Bus Ticket System',
    description: 'Learn more about our bus ticketing system and services.'
  },
  contact: {
    title: 'Contact Us - Bus Ticket System',
    description: 'Get in touch with our customer support team.'
  },
  faq: {
    title: 'FAQ - Bus Ticket System',
    description: 'Frequently asked questions about our bus ticketing system.'
  },

  // Default
  default: {
    title: 'Bus Ticket System',
    description: 'Book bus tickets online with our reliable and easy-to-use system.'
  }
};

export const getPageMetadata = (pageKey) => {
  return PAGE_METADATA[pageKey] || PAGE_METADATA.default;
};